import React from 'react';
import '../../styles/roboticsProduct.css'
import AnimatedArrowButton from '../AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../../assets/h1.png';
import product2 from '../../assets/h2.png';
import product3 from '../../assets/h3.png';
import product4 from '../../assets/h4.png';
import AnimationBox from '../../animationBox';

const HorecaFeaturedProducts= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    const cards = [
        { name: 'Atlantic Salmon Filets', company: "Sustainably sourced, rich in flavor, and ideal for fine dining." , image:product1  },
        { name: 'Artisanal Sourdough Bread', company: "Handcrafted for rich taste and a perfect crust." , image:product2  },
        { name: 'Organic Baby Spinach', company: "Fresh, nutrient-packed, and perfect for salads or cooking." , image:product3 },
        { name: 'Halal Ribeye Steak', company: "Premium halal-certified beef for luxurious dishes." , image:product4 }, 
        
      ];

    return(<div id='horecafeaturedproducts' className='roboticsproduct mt-5 pb-5 ' style={{}}>

            <AnimationBox>
            <div className='roboticsproduct-inner pt-4' >
            
            <h4 className='mx-3' style={{color:'#FFD52B',textAlign:'left'}}>Featured Products</h4>
            <hr></hr>
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>Our Featured Products</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="/Horeca-Products"   /></div> </div>
                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="/Horeca-Products"   /></div> 
                        </div>
            </div>
            
            <div style={{  maxWidth: "90%", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                overflow:'hidden',
                
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'150px',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'cover',width:'100%', height:'100%'}}></img>
                

              </div>
              <div style={{padding:'1rem' ,height:'150px'}}>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white',paddingBottom:'0.9rem',marginBottom:'0.3rem'}}>{card.company}</p>
            </div>
            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    
            </AnimationBox>
    </div>);

}

export default HorecaFeaturedProducts;